import React, { useState } from "react";
import { Box, Button, Container, Typography, TextField, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const StaffDashboard: React.FC = () => {
    const { logout, isStaff } = useAuth();
    const navigate = useNavigate();
    const [hint, setHint] = useState<string>("");

    const handlePointRegisterClick = () => {
        navigate("/point-register"); // ポイント登録画面への遷移
    };

    const handleAnnouncementRegisterClick = () => {
        navigate("/announcement-register"); // お知らせ登録画面への遷移
    };

    const handleHintRegisterClick = () => {
        navigate("/hint-register"); // ヒント投稿画面への遷移
    };

    const handleNicknameRegisterClick = () => {
        navigate("/nickname-register"); // ニックネーム登録画面への遷移
    };

    const handleLiveEventManageClick = () => {
        navigate("/live-event-manage"); // ライブ登録管理画面への遷移
    };

    const handleMonouManageClick = () => {
        navigate("/monou-room?panel=staff"); // もん王管理画面（スタッフパネル展開）へ遷移
    };

    const handleHintSubmit = () => {
        if (hint.trim()) {
            // ヒントをサーバーに送信するAPI呼び出し
            // 例: fetch('/api/hints', { method: 'POST', body: JSON.stringify({ hint }) });
            console.log(`新しいヒント: ${hint}`);
            setHint(""); // 入力フィールドをクリア
        }
    };

    const handleLogout = () => {
        logout();
        navigate('/');
    };

    if (isStaff) {
        return (
            <Container maxWidth="md" sx={{ mt: '72px', pb: 4 }}>
                <Typography variant="h4" align="center" gutterBottom sx={{ fontWeight: 700, color: '#e65100', mb: 3 }}>
                    スタッフダッシュボード
                </Typography>
                
                {/* ボタングリッド - レスポンシブ配置 */}
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: '1fr 1fr 1fr' },
                        gap: 2,
                        mb: 3,
                    }}
                >
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handlePointRegisterClick}
                        fullWidth
                        sx={{ fontWeight: 600, py: 1.5 }}
                    >
                        ポイント登録
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleAnnouncementRegisterClick}
                        fullWidth
                        sx={{ fontWeight: 600, py: 1.5 }}
                    >
                        お知らせ登録
                    </Button>
                    <Button
                        variant="contained"
                        color="warning"
                        onClick={handleLiveEventManageClick}
                        fullWidth
                        sx={{ fontWeight: 600, py: 1.5 }}
                    >
                        ライブ日程登録
                    </Button>
                    <Button
                        variant="contained"
                        color="success"
                        onClick={handleHintRegisterClick}
                        fullWidth
                        sx={{ fontWeight: 600, py: 1.5 }}
                    >
                        もんクエヒント投稿
                    </Button>
                    <Button
                        variant="contained"
                        color="info"
                        onClick={() => navigate('/event-room')}
                        fullWidth
                        sx={{ fontWeight: 600, py: 1.5 }}
                    >
                        もんクエ入室
                    </Button>
                    <Button
                        variant="contained"
                        color="warning"
                        onClick={handleMonouManageClick}
                        fullWidth
                        sx={{ fontWeight: 600, py: 1.5 }}
                    >
                        もん王管理
                    </Button>
                </Box>

                {/* ログアウトボタン */}
                <Box display="flex" justifyContent="center">
                    <Button
                        variant="outlined"
                        color="error"
                        onClick={handleLogout}
                        sx={{ fontWeight: 600 }}
                    >
                        ログアウト
                    </Button>
                </Box>
            </Container>
        );
    } else {
        return <></>;
    }
};

export default StaffDashboard;
